<template>
  <span>
    {{ getDay }} {{ $t((short ? 'monthShort' : 'monthNameNum') + '.'+getMonth) }} {{ getYear }}
  </span>
</template>

<script>
import {parse, format} from 'date-fns';

export default {
  props: {
    value: {type: String, default: undefined},
    short: {type: Boolean, default: false}
  },
  data() {
    return {
      localValue: this.value ? parse(this.value, 'yyyy-MM-dd', new Date()) : null,
    };
  },
  watch: {
    value(v) {
      this.localValue = v ? parse(v, 'yyyy-MM-dd', new Date()) : null;
    }
  },
  computed: {
    getDay() {
      return format(this.localValue, 'd');
    },
    getYear() {
      return format(this.localValue, 'yyyy');
    },
    getMonth() {
      return format(this.localValue, 'MMMM');
    },
  },
}
</script>